import { CourierWorkShift } from '@@partner:types:app'
import { gql, useMutation } from '@apollo/client'

type CourierWorkShiftInput = Pick<
  CourierWorkShift, 
  'plannedStartAt' 
  | 'plannedFinishAt' 
  | 'courier_id' 
  | 'comment'
> & {
  id?: CourierWorkShift['id']
  vehicle_id?: CourierWorkShift['vehicle_id']
  status?: number
}

type Variables = {
  newData: CourierWorkShiftInput
  upsert: boolean
}

type Mutation = {
  updateCourierWorkShift: CourierWorkShift
}

export const UPDATE_COURIER_WORKSHIFT = gql`
  mutation updateCourierWorkShift($newData: CourierWorkShiftInput, $upsert: Boolean) {
    updateCourierWorkShift(newData: $newData, upsert: $upsert) {
      id
      startedAt
      finishedAt
      plannedStartAt
      plannedFinishAt
      is_finished
      is_started
      status
      vehicle_id
      courier {
        id
        first_name
        last_name
      }
      courier_id
      comment
    }
  }
`

export const useMutateUpdateCourierWorkShift = () => useMutation<Mutation, Variables>(UPDATE_COURIER_WORKSHIFT)